<template>
  <section
    class="booking-container-mobility"
  >
    <div
      class="booking-links"
    >
      <div
        @click="bookingvalue = 0"
        :class="{ active: bookingvalue == 0 }"
        class="tab"
      >
        <svg class="booking-icon">
          <use xlink:href="#icon-car-key"></use>
        </svg>
        <span>location en agence</span>
      </div>
      <div
        @click="bookingvalue = 1"
        :class="{ active: bookingvalue == 1 }"
        class="tab"
      >
        <svg class="booking-icon">
          <use xlink:href="#icon-arrow-clock"></use>
        </svg>
        <span>libre service</span>
      </div>
    </div>

    <div
      class="booking"
      v-show="bookingvalue == 0"
    >
      <form ref="form">
        <ul
          class="booking__wrap 'not-header"
        >
          <booking-agency
            is-mobility
            :check-active="checkActive"
            class="booking__wrap--section"
            :alert-pick-up="$v.form.validationBusiness.$error"
            :alert-drop="$v.form.validationDropBusiness.$error"
          />

          <booking-date-pickers
            is-mobility
            :check-active="checkActive"
            class="booking__wrap--section"
            :alert-pick-up-date="
              $v.form.validationPickUpDate.$error
            "
            :alert-pick-up-time="
              $v.form.validationPickUpTime.$error
            "
            :alert-drop-date="$v.form.validationDropDate.$error"
            :alert-drop-time="$v.form.validationDropTime.$error"
          />
          <li
            class="reset"
            @click="reset"
          >
            <ul class="cross">
              <li />
              <li />
            </ul>
            Réinitialiser ma recherche
          </li>
          <li class="booking__wrap--btn booking__wrap--section booking-button">
            <span
              v-if="selectedVehicle && selectedVehicle.label"
              class="elem-strong"
            >Véhicule sélectionné :
              <strong>{{ selectedVehicle.label }}</strong>
            </span>
            <rent-button
              :loading="isLoading"
              @buttonclicked="attemptSubmit()"
              is-orange
              class="submit-booking"
            >
              {{ submitButtonLabel }}
            </rent-button>
            <a
              class="see-offer"
              href="/vehicules"
              v-if="selectedVehicle"
            >ou voir toutes les offres</a>
          </li>
        </ul>
      </form>
    </div>

    <div
      v-show="bookingvalue == 1"
      class="self-serve"
    >
      <div class="self-serve-container">
        <div class="self-serve-title">
          Louez comme vous le<br> souhaitez 24h/24 et 7j/7
          <rent-button
            class="self-serve-button"
            @buttonclicked="clickMobility()"
            is-anchor
            is-orange
          >
            Réservez en ligne
          </rent-button>
        </div>
        <div class="self-serve-text">
          Réservez, déverrouillez, et restituez <br> votre véhicule
          avec votre smartphone
          <div class="self-serve-subtext">
            Téléchargez l'application
          </div>
        </div>
        <div class="self-serve-app-container">
          <div class="app-button-container">
            <a
              class="app-link"
              href="https://t.rnlt.fr/ex9v0wi1bp"
              target="_blank"
            ><img
              class="app-icon"
              alt="logo"
              src="../../../../assets/images/googleplay.svg"
            ></a>

            <a
              class="app-link"
              href="https://t.rnlt.fr/avxx795qf0"
              target="_blank"
            ><img
              class="app-icon"
              alt="logo"
              src="../../../../assets/images/app-store.svg"
            ></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import BookingAgency from '../Booking/BookingAgency'
import BookingDatePickers from '../Booking/BookingDatePickers'
// import BookingCarList from '../Booking/BookingCarList/BookingCarList'
import RentButton from '../shared/RentButton'
import { removeCompletedBookingInfo } from '../../utils/setLocalStorage'

export default {
  name: 'MobilityBooking',
  components: {
    BookingAgency,
    BookingDatePickers,
    RentButton,
    // BookingCarList,
  },
  props: {
  },

  mounted() {
    this.$store.commit('ui/SET_FORM_ELEMENT', this.$refs.form)
    window.addEventListener('scroll', this.updateScroll)
  },
  destroy() {
    window.removeEventListener('scroll', this.updateScroll)
  },
  data() {
    return {
      checkActive: true,
      bookingvalue: window.renaultRent.ls ? 1 : 0,
      form: {
        validationBusiness: this.pickUpBusiness,
        validationDropBusiness: this.dropBusiness,
        validationPickUpDate: this.pickUpDate,
        validationPickUpTime: this.pickUpTime,
        validationDropDate: this.dropDate,
        validationDropTime: this.dropTime,
      },
      isLoading: false,
      scrollPosition: null,
    }
  },
  computed: {
    ...mapState({
      oneWay: (state) => state.booking.oneWay,
      pickUpBusiness: (state) => state.booking.pickUp.business,
      dropBusiness: (state) => state.booking.drop.business,
      pickUpDate: (state) => state.booking.pickUp.date,
      pickUpTime: (state) => state.booking.pickUp.time,
      dropDate: (state) => state.booking.drop.date,
      dropTime: (state) => state.booking.drop.time,
      steps: (state) => state.stepping.steps,
      attemptingNavigation: (state) => state.stepping.attemptingNavigation,
      selectedVehicle: (state) => state.vehicles.set.storeVehicle,
      currentLayout: (state) => state.layout,
      vehicleList: (state) => state.ui.listElement,
      userInfo: (state) => state.user.details,
    }),
    ...mapGetters({
      BookingVehicleProfileRequested: 'user/isGetProfileRequested',
      BookingVehicleUserIsLogged: 'auth/userIsLogged',
      canGetPrices: 'vehicles/canGetPrices',
    }),
    datesAndBusinessReady() {
      return this.$store.getters['booking/datesAndBusinessReady']
    },
    submitButtonLabel() {
      if (this.isMobility || !this.isZoe) {
        if (this.selectedVehicle && this.dropTime) {
          return this.$t('components.booking.see-estimate')
        }
        return this.$t('components.booking.search')
      }
      if (this.selectedVehicle && this.selectedVehicle.label) {
        return this.$t('components.booking.submit-with-vehicle', {
          vehicleLabel: this.selectedVehicle.label,
        })
      }

      return this.$t('components.booking.submit')
    },
    showHeader() {
      return this.$store.state.stepping.header
    },

  },
  validations: {
    form: {
      validationBusiness: { required },
      validationPickUpDate: { required },
      validationPickUpTime: { required },
      validationDropDate: { required },
      validationDropTime: { required },
      validationDropBusiness: { required },
    },
  },
  methods: {
    reset() {
      this.checkActive = false
      this.$store.commit('booking/SET_PICKUP_BUSINESS', '')
      this.$store.commit('booking/SET_DROP_BUSINESS', '')
      this.$store.commit(
        'booking/SET_BUSINESS_LOCAL_STORAGE_CHECKED_FALSE',
      )
      this.$store.commit('booking/SET_DROP_BUSINESS', '')
      this.$store.commit('vehicles/SET_SELECTED_VEHICLE', '')
      const result = new Date()
      result.setDate(result.getDate() + 7)
      this.$store.commit('booking/SET_PICKUP_DATE', result)
      this.$store.commit('booking/SET_PICKUP_TIME', null)
      this.$store.commit('booking/SET_DROP_DATE', null)
      this.$store.commit('booking/SET_DROP_TIME', null)

      removeCompletedBookingInfo()
      localStorage.removeItem('rentPickupDate')
      localStorage.removeItem('rentPickupTime')
      localStorage.removeItem('rentDropDate')
      localStorage.removeItem('rentDropTime')
    },
    attemptSubmit() {
      this.updateForms()
      this.$v.form.$touch()
      if (this.$v.form.$error) return

      if (!this.selectedVehicle) {
        this.analytics()
        return this.showVehicles()
      }
      this.submitForm()
    },
    showVehicles() {
      if (this.currentLayout === 'vehicles-layout') {
        this.isLoading = true
        setTimeout(() => {
          this.hideHeader()
        }, 1000)

        if (this.isHome) this.analytics()
        return this.vehicleList.scrollIntoView({ behavior: 'smooth' })
      }

      this.navigateToVehiclesPage()
    },
    navigateToVehiclesPage() {
      return this.$store.commit('stepping/TRIGGER_STEP_NAVIGATION', {
        step: 0,
      })
    },
    submitForm() {
      this.$store.dispatch('stepping/VALIDATE_STEP_1')
    },
    updateForms() {
      // TODO We need to make it cleaner
      this.form.validationBusiness = this.pickUpBusiness
      this.form.validationPickUpDate = this.pickUpDate
      this.form.validationPickUpTime = this.pickUpTime
      this.form.validationDropDate = this.dropDate
      this.form.validationDropTime = this.dropTime
      // double check that the One Way is select or not
      // if not, just fill it up with whatever so it doesn't show an alert
      this.form.validationDropBusiness = this.oneWay
        ? this.dropBusiness
        : !this.oneWay
    },
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    hideHeader() {
      this.$store.commit('stepping/SET_HEADER', false)
    },
    analytics() {
      if (!window.dataLayer) {
        return
      }
      const event = 'continuerlaReservation'
      const departureAgency = this.pickUpBusiness?.label
      const loginStatus = this.BookingVehicleProfileRequested
        ? this.BookingVehicleUserIsLogged
        : 'N/A'
      const page = window.location.href
      const pageTitle = document.querySelector('head title')?.text
      const returnAgency = this.pickUpBusiness?.label || this.dropBusiness?.label
      const userId = this.BookingVehicleUserIsLogged
        ? this?.userInfo?.email
        : null
      const payload = {
        event,
        page,
        departureAgency,
        loginStatus,
        pageTitle,
        returnAgency,
        userId,
      }
      window.dataLayer.push(payload)
    },
    clickMobility() {
      this.analytics2()
      window.open('https://t.rnlt.fr/i318d6mf9k', '_blank')
    },
    analytics2() {
      if (!window.dataLayer) {
        return
      }
      const event = 'navigationClick'
      const pageTitle = document.querySelector('head title')?.text
      const pageType = ''
      const buttonText = 'Réservez en ligne'
      const destination = 'https://t.rnlt.fr/i318d6mf9k'
      const payload = {
        event,
        pageTitle,
        pageType,
        buttonText,
        destination,
      }
      window.dataLayer.push(payload)
    },
  },
}
</script>

<style lang="scss">
@import '../../../../_src/sass/config/vars';
@import '../../../../_src/sass/config/mixins';
@import '../../../../_src/sass/config/responsive';

.booking-container-mobility {
  background: white;
  display: flex;
  flex-direction: column;
  gap: 4rem;
  margin: 0 1.7rem;
  padding: 0 2.5rem 4rem;

  @include teq-breakpoint($large) {
    background: #f5f5f5;
    left: 13rem;
    margin: 0;
    padding: 4.8rem 1.4rem 4rem;
    position: absolute;
    top: 8rem;
    width: 38rem;
  }

  @include teq-breakpoint($xxxl) {
    top: 50%;
    transform: translateY(-50%);
  }

  .reset {
    bottom: 8px;
    color: black;
    cursor: pointer;
    font-family: $f-graphie-book;
    left: 13px;
    position: relative;

    @include font-size(13px);

    .cross {
      @include rotate(45deg);

      bottom: 5px;
      cursor: pointer;
      height: 10px;
      left: -15px;
      padding: 3px;
      position: absolute;
      width: 10px;

      li {
        background-color: $black;
        height: 1px;
        width: 10px;

        &:nth-child(2) {
          @include rotate(90deg);

          margin-top: -1px;
        }
      }
    }
  }

  .submit-booking {
    height: auto;
    margin: 1.6rem 0 0.8rem;
    max-width: 100%;
    min-height: auto;
    padding: 1.2rem 0;
  }

  .booking {
    .date-pickers {
      padding: 0;
      padding-bottom: 1.4rem;

      .flex-container {
        //gap: 2rem;
      }
    }

    .agency {
      margin-bottom: 2.4rem;

      li {
        margin: 0;
      }
    }

    .booking-button {
      margin-top: 1.5rem;

      @include teq-breakpoint($large) {
        margin-top: 2.7rem;
      }
    }

    .agency__checkbox {
      margin: 0;
    }
  }

  .booking-links {
    display: flex;
    justify-content: space-around;
    margin-left: -2.5rem;
    width: calc(100% + 5rem);

    @include teq-breakpoint($large) {
      gap: 2.3rem;
      justify-content: flex-start;
      margin-left: 0;
      width: 100%;
    }

    .tab {
      align-items: center;
      background: black;
      color: white;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      font-family: $f-graphie-book;
      font-size: 1.6rem !important;
      gap: 1.1rem;
      line-height: 1.8rem !important;
      padding-bottom: 2.8rem;
      padding-top: 2.4rem;
      width: 50%;

      @include teq-breakpoint($large) {
        background: transparent;
        color: black;
        flex-direction: row;
        gap: 0;
        padding-bottom: 1rem;
        padding-top: 0;
        width: initial;
      }

      &.active {
        background: white;
        color: black;
        font-family: $f-graphie-semibold;

        @include teq-breakpoint($large) {
          background: transparent;
          border-bottom: 2px solid $orange;
        }

        span {
          border-bottom: 2px solid $orange;

          @include teq-breakpoint($large) {
            border-bottom: 0;
          }
        }

        svg {
          fill: black;
        }
      }

      svg {
        fill: white;
        height: 18px;
        margin-right: 0.8rem;
        width: 18px;

        @include teq-breakpoint($large) {
          fill: black;
        }
      }
    }
  }

  .self-serve-title {
    font-family: $f-graphie-semibold;
    font-size: 2.4rem;
    line-height: 2.8rem;
    margin-bottom: 1.6rem;
  }

  .self-serve-button {
    height: auto;
    margin-top: 1.6rem;
    min-height: auto;
    padding: 1.2rem 0;
  }

  .self-serve-text {
    border-top: 1px solid #c4c4c4;
    font-family: $f-graphie-semibold;
    font-size: 1.8rem;
    line-height: 2.2rem;
    padding-top: 2.4rem;

    .self-serve-subtext {
      font-family: $f-graphie-book;
      font-size: 1.4rem;
      margin-bottom: 1.5rem;
    }
  }

  .app-button-container {
    display: flex;
    gap: 1.7rem;
    justify-content: space-between;

    @include teq-breakpoint($large) {
      gap: 2.9rem;
    }

    .app-icon {
      height: 5rem;
    }
  }

  .see-offer {
    color: black;
    text-decoration: underline;
  }

  .elem-strong {
    margin-bottom: 1.6rem;

    strong {
      font-family: $f-graphie-semibold;
    }
  }
}
</style>
